import { ErrEmailAlreadyExists, ErrEmailDomainNotAllowed } from '@/core/address';
import { APIError, ERROR_CODES, hasErrorCode } from '@/core/api';

// The createUser rejections the account step shows inline, next to the email
// field. They are designed outcomes of a signup form, not failures, so the
// modal hook doesn't report them to Sentry (ENG-5769). One list serves both,
// so a message AccountStep handles can't keep paging.
export function accountStepFieldErrors(err: unknown): { email: string } | undefined {
  // An APIError's own message carries a "GraphQL Error: " prefix, so match the
  // server's message instead, as handleSignupError and useSMBSignup do.
  const serverMessage = err instanceof APIError ? err.rawError[0]?.message : undefined;
  if (
    hasErrorCode(err, ERROR_CODES.AUTH_ACCOUNT_EXISTS_LOGIN_REQUIRED) ||
    hasErrorCode(err, ERROR_CODES.AUTH_EMAIL_ALREADY_EXISTS) ||
    serverMessage === ErrEmailAlreadyExists.message
  ) {
    return { email: 'An account with this email already exists.' };
  }
  if (serverMessage === ErrEmailDomainNotAllowed.message) {
    return { email: 'Email domain not allowed to sign up' };
  }
  return undefined;
}
